/**
 * replacement for react-icon-base@2.1.0 (unmaintained since 2017).
 */
'use strict';

var React = require('react');

function IconBase(props, legacyContext) {
  var children = props.children;
  var color = props.color;
  var size = props.size;
  var style = props.style;
  var width = props.width;
  var height = props.height;

  var rest = {};
  for (var key in props) {
    if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
    if (key === 'children' || key === 'color' || key === 'size' ||
        key === 'style' || key === 'width' || key === 'height') continue;
    rest[key] = props[key];
  }

  var base = (legacyContext && legacyContext.reactIconBase) || {};

  var computedSize = size || base.size || '1em';

  var svgProps = {
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  };
  Object.assign(svgProps, base, rest);

  svgProps.style = Object.assign(
    { verticalAlign: 'middle', color: color || base.color },
    base.style || {},
    style
  );

  return React.createElement('svg', svgProps);
}

module.exports = IconBase;
